// extracted by mini-css-extract-plugin
module.exports = {"Container":"VideoBackground_Container__3Ud8K","Video":"VideoBackground_Video__34J5a","Content":"VideoBackground_Content__2H9D-","SubContent":"VideoBackground_SubContent__2YsKl"};